/** A guest/attendee from the calendar invitation (ahoy_invitations property) */
export interface CalendarEventGuest {
  email: string;
  name?: string;
  /** RSVP status: 'accepted' | 'declined' | 'tentative' | 'needs_action' | 'removed' */
  response_status?: string;
  is_organizer?: boolean;
  is_optional?: boolean;
}

/** Raw invitation structure from ahoy_invitations multi-valued property */
export interface RawInvitation {
  email?: string;
  invitee_name?: string;
  response_status?: string;
  is_organizer?: string;
  is_optional?: string;
}

/**
 * Map ahoy_invitations property to CalendarEventGuest array.
 */
export function mapInvitationsToGuests(
  invitations: RawInvitation[] | undefined
): CalendarEventGuest[] {
  if (!invitations || !Array.isArray(invitations)) {
    return [];
  }

  return invitations
    .filter((inv): inv is RawInvitation & { email: string } => {
      return !!inv.email;
    })
    .map(inv => ({
      email: inv.email,
      name: inv.invitee_name,
      response_status: inv.response_status,
      is_organizer: inv.is_organizer === 'true',
      is_optional: inv.is_optional === 'true',
    }))
    .sort((a, b) => (a.name || a.email).localeCompare(b.name || b.email));
}
